import React from 'react'
import Socks from '../Socks'


export default function Product() {
  return (
    <div>
      <Socks/>
    </div>
  )
}
